import {TripCollection} from "../Trip";
import sibiu from "../../../assets/child/sibiu.jpg";

const dayChildSibiu: TripCollection = {
    imageSrc: sibiu,
    trips: [
        {
            name: "3.1. Sibiu I",
            route: "Braşov – Avrig – Sibiu – Braşov",
            days: [
                [
                    {
                        locationName: "Brambura Park – Casa Întoarsă",
                    },
                    {
                        locationName: "Muzeul A.S.T.R.A.",
                    },
                    {
                        locationName: "Muzeul de Istorie Naturală",
                    },
                    {
                        locationName: "Tur Centru Istoric",
                    },
                ]
            ],
            notes: "O zi plină de descoperiri, îmbinând atracțiile inedite cu patrimoniul cultural autentic al Transilvaniei. Prima oprire are loc la Brambura Park din Avrig, unde celebra Casă Întoarsă oferă o experiență inedită, distractivă și perfectă pentru realizarea unor fotografii memorabile. Traseul continuă către Sibiu, unde vizita Muzeului Civilizației Populare Tradiționale A.S.T.R.A. oferă o incursiune autentică în viața și tradițiile satului românesc, într-un cadru natural deosebit. Programul include și Muzeul de Istorie Naturală, un spațiu educativ și captivant, ce prezintă diversitatea lumii naturale prin colecții valoroase de zoologie, botanică și geologie. Excursia se încheie cu un tur pietonal al Centrului Istoric din Sibiu, prilej de a descoperi piețele emblematice, clădirile istorice și atmosfera aparte a unuia dintre cele mai frumoase orașe din România."
        },
        {
            name: "3.2. Sibiu II",
            route:
                "Braşov – Sibiu – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Palatul Brukenthal (Galeria de Arta Românească)",
                        },
                        {
                            locationName: "Turnul Sfatului",
                        },
                        {
                            locationName: "Tur Centru Istoric",
                        },
                        {
                            locationName: "Muzeul A.S.T.R.A.",
                        },
                    ]
                ],
            notes:
                "Programul propune o incursiune culturală în inima Transilvaniei, într-un oraș cu un patrimoniu istoric și artistic deosebit. Vizita la Palatul Brukenthal, una dintre cele mai importante instituții muzeale din România, oferă acces la Galeria de Artă Românească, unde sunt expuse colecții valoroase ce ilustrează evoluția artei naționale. Experiența continuă cu urcarea în Turnul Sfatului, punct de belvedere ce oferă o panoramă spectaculoasă asupra centrului istoric. Turul pietonal al orașului vechi permite descoperirea principalelor piețe, clădirilor emblematice și atmosferei autentice a Sibiului. Programul este completat de vizita Muzeului Civilizației Populare Tradiționale A.S.T.R.A., cel mai mare muzeu în aer liber din România, dedicat tradițiilor și vieții rurale, amplasat într-un cadru natural deosebit."
        }
        ,
        {
            name: "3.3. Sibiu III",
            route:
                "Braşov – Sibiu – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Muzeul de Istorie Naturală",
                        },
                        {
                            locationName: "Turnul Sfatului",
                        },
                        {
                            locationName: "Tur Centru Istoric",
                        },
                        {
                            locationName: "Muzeul A.S.T.R.A.",
                        },
                    ]
                ],
            notes:
                "Programul include vizitarea Muzeului de Istorie Naturală, un spațiu educativ și captivant ce prezintă diversitatea lumii naturale prin colecții de zoologie, botanică și geologie. Experiența continuă cu urcarea în Turnul Sfatului, punct de belvedere emblematic, de unde se poate admira o panoramă spectaculoasă asupra centrului istoric al orașului. Turul pietonal al centrului vechi oferă prilejul de a descoperi piețele reprezentative, clădirile istorice și atmosfera specifică orașului Sibiu. Vizita este completată de Muzeul Civilizației Populare Tradiționale A.S.T.R.A., cel mai mare muzeu în aer liber din România, dedicat tradițiilor și vieții rurale, amplasat într-un cadru natural deosebit."
        }
        ,
        {
            name: "3.4. Sibiu IV",
            route:
                "Braşov – Sibiu – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Turnul Sfatului",
                        },
                        {
                            locationName: "Tur Centrul Istoric",
                        },
                        {
                            locationName: "Grădina Zoologică",
                        },
                        {
                            locationName: "Muzeul A.S.T.R.A.",
                        },
                    ]
                ],
            notes:
                "Programul oferă o experiență variată, îmbinând descoperirea patrimoniului istoric cu momente de relaxare în mijlocul naturii. Vizita la Turnul Sfatului permite admirarea unei panorame spectaculoase asupra centrului istoric, evidențiind arhitectura specifică orașului Sibiu. Turul pietonal al centrului vechi oferă ocazia de a explora piețele reprezentative, clădirile emblematice și atmosfera autentică a acestui important centru cultural. Experiența continuă la Grădina Zoologică, un spațiu modern și plăcut, ideal pentru toate categoriile de vizitatori, unde pot fi observate numeroase specii de animale într-un cadru natural bine întreținut. Programul este completat de vizita Muzeului Civilizației Populare Tradiționale A.S.T.R.A., cel mai mare muzeu în aer liber din România, dedicat tradițiilor și vieții rurale, amplasat într-un cadru natural deosebit."
        }
        ,
    ]
}

export default dayChildSibiu;